export interface ProblemDetail {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  message?: string;
  properties?: { trace?: string; code?: string };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isProblemDetail(value: any): value is ProblemDetail {
  return typeof value === 'object' && value !== null && 'status' in value && 'type' in value;
}

const codeOf = (value: unknown): string | undefined => {
  if (typeof value !== 'object' || value === null) {
    return undefined;
  }

  const properties = (value as { properties?: { code?: unknown } }).properties;
  return typeof properties?.code === 'string' ? properties.code : undefined;
};

/**
 * The typed error code (`properties.code`) from a failed request, regardless of which
 * client produced the error: the ordr-service fetcher throws the ProblemDetail body
 * directly, while the BFF client wraps it in an ApiError with the body on `errorBody`
 * (the BFF strips the `type` field, so isProblemDetail does not match those bodies).
 */
export const getErrorCode = (error: unknown): string | undefined => {
  const direct = codeOf(error);
  if (direct) {
    return direct;
  }

  if (typeof error === 'object' && error !== null && 'errorBody' in error) {
    return codeOf((error as { errorBody?: unknown }).errorBody);
  }

  return undefined;
};
